const menu = {
  "sim": "SIM",
  "store": "Сохранить",
  "index": "Главная",
  "overview": "Обзор",
  "home": "Главная",
  "supervise": "Управление",
  "device": "Устройства",
  "watch": "Управление устройствами",
  "superviseTemplate": "Правила",
  "superviseCenter": "Центр управления",
  "entityTemplate": "Настройки шаблонов",
  "org": "Орг.",
  "alarm": "Тревога",
  "alarmSetting": "Настройки тревог",
  "alarmList": "Список тревог",
  "systemLog": "Журнал системы",
  "system": "Система",
  "deviceModel": "Модель",
  "systemSetting": "Настройки системы",
  "visit": "Вход",
  "statistics": "Обзор",
}
export default menu